import {Routes} from '@angular/router';
import {LandingPageComponent} from "./components/landing-page/landing-page.component";
import {HomeComponent} from "./components/home/home.component";
import {EventsComponent} from "./components/events/events.component";
import {ScoreboardComponent} from "./components/scoreboard/scoreboard.component";
import {UserComponent} from "./components/user/user.component";
import {SingleEventComponent} from "./components/single-event/single-event.component";
import {ScoreboardTableComponent} from "./components/scoreboard-table/scoreboard-table.component";
import {authGuard} from "./core/guards/auth.guard";
import {adminGuard} from "./core/guards/admin.guard";
import {LoginComponent} from "./components/login/login.component";
import {PatreonLinkComponent} from "./components/patreon-link/patreon-link.component";
import {GoogleLinkComponent} from "./components/google-link/google-link.component";
import {DataPolicyGoogleComponent} from "./components/data-policy-google/data-policy-google.component";
import {SettingsComponent} from "./components/settings/settings.component";

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    title: 'Spotfight Tippspiel',
  },
  {
    path: 'data-privacy/google',
    component: DataPolicyGoogleComponent,
    title: 'Spotfight Tippspiel',
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'Spotfight Tippspiel | Login',
  },
  {
    path: 'home',
    component: HomeComponent,
    title: 'Der Ring',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'events/:league/:uuid',
        component: SingleEventComponent,
        title: 'Events',
      },
      {
        path: 'events',
        component: EventsComponent,
        title: 'Events',
      },
      {
        path: 'user',
        component: UserComponent,
        title: 'Home'
      },
      {
        path: 'scoreboard',
        component: ScoreboardComponent,
        title: 'Bestenliste',
        children: [
          {
            path: ':league',
            component: ScoreboardTableComponent,
            title: 'Bestenliste',
          }
        ]
      },
      {
        path: 'settings',
        component: SettingsComponent,
        title: 'Settings'
      },
      {
        path: 'oauth/v2/patreon',
        component: PatreonLinkComponent,
        title: 'Link Patreon Account',
      },
      {
        path: 'oauth/v2/google',
        component: GoogleLinkComponent,
        title: 'Spotfight Tippspiel',
      },
      {
        path: 'admin/events/:function/:league/:uuid',
        loadComponent: () => import("./components/event-edit/event-edit.component").then(m => m.EventEditComponent),
        // component: EventEditComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/events/create/:function',
        // component: EventEditComponent,
        loadComponent: () => import("./components/event-edit/event-edit.component").then(m => m.EventEditComponent),
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/events',
        // component: AdminListEventsComponent,
        loadComponent: () => import("./components/admin-list-events/admin-list-events.component").then(m => m.AdminListEventsComponent),
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/youtube',
        loadComponent: () => import("./components/youtube-members-upload/youtube-members-upload.component").then(m => m.YoutubeMembersUploadComponent),
        // component: YoutubeMembersUploadComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/email',
        loadComponent: () => import("./components/email-newsletter/email-newsletter.component").then(m => m.EmailNewsletterComponent),
        // component: YoutubeMembersUploadComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/season/edit',
        loadComponent: () => import("./components/admin-season-edit/admin-season-edit.component").then(m => m.AdminSeasonEditComponent),
        // component: YoutubeMembersUploadComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/season/reset',
        loadComponent: () => import("./components/admin-season-reset/admin-season-reset.component").then(m => m.AdminSeasonResetComponent),
        // component: YoutubeMembersUploadComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin/banner/upload',
        loadComponent: () => import("./components/admin-upload-banner/admin-upload-banner.component").then(m => m.AdminUploadBannerComponent),
        // component: YoutubeMembersUploadComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
      {
        path: 'admin',
        loadComponent: () => import("./components/admin/admin.component").then(m => m.AdminComponent),
        // component: AdminComponent,
        title: 'Admin',
        canActivate: [authGuard, adminGuard],
      },
    ]
  },

];
